// extracted by mini-css-extract-plugin
module.exports = {"form":"reset-password_form__BaNTn","block":"reset-password_block__121RX"};